<template>
  <b-badge :variant="variant" class="badge-sm">
    {{ displayText }}
  </b-badge>
</template>

<script>
import { WARRANTY_OUTSOURCE_STATUS } from '@/utils/enum';
import { WARRANTY_OUTSOURCE_STATUS_NAME } from '@/utils/enum-name';

export default {
  name: 'OutsourceStatusBadge',
  props: {
    status: {
      type: String,
      default: null,
    },
    statusName: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayText() {
      return (
        this.statusName ||
        (this.status && WARRANTY_OUTSOURCE_STATUS_NAME[this.status]) ||
        '—'
      );
    },
    variant() {
      switch (this.status) {
        case WARRANTY_OUTSOURCE_STATUS.SENT:
          return 'warning';
        case WARRANTY_OUTSOURCE_STATUS.RECEIVED:
          return 'success';
        case WARRANTY_OUTSOURCE_STATUS.CANCELLED:
          return 'danger';
        default:
          return 'light';
      }
    },
  },
};
</script>
